import {
  CenteredContent,
  DesignVersionProvider,
  IllustrationSmooth,
  SpacerVertical
} from 'mage-deps/@klarna/bubble-ui'
import { Framework, FrameworkContext } from 'mage-deps/@klarna/mp-ui'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import React, { useContext, useEffect } from 'react'

import EnvironmentIdentifier from '../EnvironmentIdentifier'

const Content = ({ until, t }) => {
  const { setTopBarContext = () => {} } = useContext(FrameworkContext)

  useEffect(() => {
    const title = t('core.maintenance.pageTitle')
    setTopBarContext({ title })
    document.title = title
  }, [t])

  let summary
  if (until) {
    const untilTime = moment(parseInt(until, 10)).format('h:mma z')
    summary = t('core.maintenance.scheduledSummary', { until: untilTime })
  } else {
    summary = t('core.maintenance.summary')
  }

  return (
    <>
      <SpacerVertical large />
      <CenteredContent
        illustration={<IllustrationSmooth />}
        title={t('core.maintenance.title')}
        summary={summary}
      />
    </>
  )
}

Content.propTypes = {
  until: PropTypes.string,
  t: PropTypes.func.isRequired
}

const Maintenance = ({ footerConfig, designVersion, until, t }) => {
  return (
    <>
      <EnvironmentIdentifier />
      <Framework footerConfig={footerConfig}>
        <DesignVersionProvider value={designVersion}>
          <Content t={t} until={until} />
        </DesignVersionProvider>
      </Framework>
    </>
  )
}

Maintenance.propTypes = {
  footerConfig: PropTypes.shape({
    text: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        linkText: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired
      })
    )
  })
    .isRequired,
  designVersion: PropTypes.string,
  until: PropTypes.string,
  t: PropTypes.func.isRequired
}

export default Maintenance

export {
  Content
}
